import { getToken, setToken, removeToken, getUserInfo, setUserInfo, removeUserInfo } from '@/utils/auth'
import { post } from '@/plugins/axios/axiosUtil'

// 村赤用户令牌和角色信息
const state = {
    token: getToken(),
    userInfo: [],
    roles: [] //角色
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles;
    },
    SET_USERINFO: (state, userInfo) => {
        state.userInfo = userInfo;
    }
};

const actions = {
    gitRemoteData({ state, commit, dispatch }, param) {
        let jiamiParam =
            // '2k3U91ekS7WoODp/M90DWjwlLyP8LVHE';
            param.params ? param.params : { ID: 59 };
        let msg = {
            "data": jiamiParam,
        };
        return post(param.url, msg).then((response) => {
            if (response) {
                let temp = response;
                return Promise.resolve(temp);
            } else {
                return Promise.reject('没有数据');
            }

        });

    },
    // 用户登录
    login({ commit, dispatch }, userInfo) {
        var url = "/60001/login";
        return dispatch("gitRemoteData", { url, params: userInfo }).then(jsonObjData => {
            commit('SET_TOKEN', jsonObjData.token);
            commit('SET_HOS_NAME', jsonObjData.data.name);
            commit('SET_USERINFO', jsonObjData.data);
            localStorage.setItem("token", jsonObjData.token)
            jsonObjData.data.login_id = userInfo.username
            localStorage.setItem("userInfo", JSON.stringify(jsonObjData.data))

            setUserInfo(jsonObjData.data);
            setToken(jsonObjData.token);

            var url = "/60701/QueryUserRule";
            //此处为核心代码
            return dispatch("gitRemoteData", { url }).then(async jsonObjData => {

                localStorage.setItem('menu', JSON.stringify(jsonObjData.data));

                let button_permissions = []
                    //按钮权限
                jsonObjData.data.forEach(item => {
                        if (item.ismenu == 2) {
                            button_permissions.push(item.name)
                        }
                    })
                    //不需要鉴权的按钮权限（请求方法的url）,类型为['a/a','b/b']
                var noRolePerms = [];
                button_permissions.push(noRolePerms);
                localStorage.setItem('button_permissions', JSON.stringify(button_permissions))
                    // commit("SET_PERMISSION",button_permissions);
                    // console.log('data1',data)

            });

        });
        Promise.resolve()
    },
    // 获取用户角色信息
    getInfo({ commit, state }) {
        return new Promise((resolve) => {
            setTimeout(() => {
                const roles = JSON.parse(localStorage.getItem('menu'));
                commit('SET_ROLES', roles);
                resolve({ roles });
            }, 1000);
        })
    },
    // 重置令牌
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_USERINFO', null)
            commit('SET_ROLES', [])
                // removeToken();
            localStorage.clear();
            removeUserInfo();
            resolve();
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}